import mixin from '../../../mixins/mixin';
import airbnbService from '../../../services/airbnb';
import rentalService from '../../../services/rental';
import accountService from './../../../services/account';

export default {
  data() {
    return {
      airbnbAccounts: [],
      selectedOption: 'owner_account',
      email_another_account_airbnb: '',
      currentAirbnbXmId: '',
      listings: [],
      code: '',
      token: '',
      rentals: [],
      options: [
        { label: 'Ne rien faire', value: '' },
        { label: 'Créer un nouveau hébergement', value: 'create_new' },
      ],
      loading: false,
      loadingRentals: false,
      airbnbActiveLoading: false,
      callback_url: 'airbnb_account',
      airbnbActiveStep: 1,
      abAccount: {
        error: null,
        errorMsg: '',
        loading: false,
        verified: false,
        airbnbPassword: '',
        airbnbUsername: '',
        afterAirlock: false,
        allRentalsSelected: false,
        mfaOptions: [],
        tempId: null,
      },
      user: {},
    };
  },
  components: {
    VLayout: require('layouts/default/default.vue'),
    VPanel: require('components/panel/panel.vue'),

    VLoading: require('components/loading/loading.vue'),

  },
  mixins: [mixin],
  async mounted() {
    this.getAccountAirbnbDisconnect();

    /* get all rentals */
    this.getAllRentals();
    /* all rentals */

    const hash = window.location.hash;
    const queryString = hash.includes('?') ? hash.split('?')[1] : '';
    const params = new URLSearchParams(queryString);
    this.code = params.get('channel_id');
    this.token = params.get('token');

    if (this.code && this.token) {
      airbnbService.userCreate(this).then((response) => {
        if (this.currentAirbnbXmId !== '' && this.currentAibnbAccountId !== '') {
          this.airbnbAllListing();
        }
      });
    }
  },
  methods: {

    airbnbAllListing() {
      airbnbService.getListings(this).then((response) => {
        this.airbnbActiveLoading = false;
        this.showAddNewAccount(3);
      });
    },

    showAddNewAccount(airbnbActiveStep = 1) {
      const vm = this;
      this.airbnbActiveStep = airbnbActiveStep;
      this.abAccount = {
        id: null,
        error: null,
        errorMsg: '',
        loading: false,
        verified: false,
        airbnbPassword: '',
        airbnbUsername: '',
        afterAirlock: false,
        allRentalsSelected: false,
        mfaOptions: [],
        tempId: null,
      };
      this.selectedOption = 'owner_account';
      this.email_another_account_airbnb = '';
      vm.openModal('.add-new-airbnb-account');
    },

    getAccountAirbnbDisconnect() {
      this.loading =false;
      const vm = this;
      accountService.getAirbnbAccounts(vm);
    },

    airbnbConnectAibnb() {
      this.abAccount.errorMsg = '';
      switch (this.airbnbActiveStep) {
        case 1:
          if (this.selectedOption === 'owner_account') {
            this.airbnbActiveStep = 2;
          } else if (this.email_another_account_airbnb !== '') {
            this.airbnbActiveStep = 2;
          }
          break;
        case 2:
          if (this.selectedOption === 'owner_account') {
            this.disableConnectAirbnbBtn = true;
            airbnbService.connectionLink(this).then((response) => {
              this.disableConnectAirbnbBtn = false;
              if (this.redirectlink) {
                window.open(this.redirectlink, '_blank');
              }
            });
          } else {
            this.airbnbActiveStep = 3;
          }
          break;
        case 3:
          airbnbService.listingCreate(this).then((response) => {
            console.log(response, '[POST] /airbnb/listings');
            this.getAllRentals();
            this.getAccountAirbnbDisconnect();
            this.dismissModal();
            this.listings = [];
          });
          break;
      }
    },

    dismissModal() {
      this.closeModal('.add-new-airbnb-account');
    },

    getAllRentals() {
      this.loadingRentals = true;
      rentalService.getRentalsList(this).then((response) => {
        const rentalsWithNullAirbnbAccountId = this.rentals.filter(rental => (rental.airbnb_rental_id != null && rental.airbnb_rental_id != ''));
        this.rentals.forEach((rental) => {
          this.options.push({ label: rental.name, value: rental.id });
        });

        this.rentals = rentalsWithNullAirbnbAccountId;
        this.loadingRentals = false;
      });
    },

    prevStep() {
      if (this.airbnbActiveStep !== 1) {
        this.airbnbActiveStep = this.airbnbActiveStep - 1;
      }
    },

    deleteAirbnbAccount(airbnbAccountId) {
      const vm = this;
      swal({
        title: this.$t('account.settings.user_platforms_section.delete_airbnb_account_title'),
        text: `<div style="display: none; height: 100px" id="loading1" class="loader-wrapper"><div class="md-preloader"><svg xmlns="http://www.w3.org/2000/svg" version="1.1" height="75" width="75" viewbox="0 0 75 75"><circle cx="37.5" cy="37.5" r="33.5" stroke-width="4"/></svg></div></div><div>${this.$t('account.settings.user_platforms_section.delete_airbnb_account_desc')} ${airbnbAccountId} ?</div>`,
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: this.$t('button.cancel'),
        confirmButtonClass: 'btn-success',
        confirmButtonText: this.$t('swal_popup.confirm_delete'),
        closeOnConfirm: true,
        html: true,
      },
        async function (isConfirm) {
          if (isConfirm) {
            await accountService.deleteAirbnbAccount(vm, airbnbAccountId);
          } else {
            swal('Success!', this.$t('account.update_success'), 'success');
          }
        });
    },

    openImportAirbnbXmlNewRentalsModal(account) {
      this.listings = [];
      this.airbnbActiveLoading = true;
      this.currentAirbnbXmId = account.airbnbxml_channel_id;
      this.currentAibnbAccountId = account.id;
      this.airbnbAllListing();
    },

    reconnectAirbnbAccountWithAirbnbXml(accountId) {
      const abAccount = this.airbnbAccounts.find(account => account.id == accountId);
      const vm = this;
      this.airbnbActiveStep = 1;
      this.selectedOption = 'owner_account';
      this.email_another_account_airbnb = '';
      this.abAccount = {
        ...this.abAccount,
        id: abAccount.id,
        airbnbUsername: abAccount.username,
        airbnbPassword: '',
        accountId: abAccount.id,
        afterAirlock: false,
        errorMsg: '',
        mfaOptions: [],
        tempId: null,
      };

      vm.openModal('.add-new-airbnb-account');
    },
  },
  watch: {},
  computed: {
  },
};



// WEBPACK FOOTER //
// ./src/app/pages/account/airbnb-account/index.js